import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=6bc682c6"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconPencil: require('/home/userapp/components/Atom/Icon/IconPencil.vue').default,IconCheckmark: require('/home/userapp/components/Atom/Icon/IconCheckmark.vue').default,IconPowerSwitch: require('/home/userapp/components/Atom/Icon/IconPowerSwitch.vue').default})
